
import React, { useState } from 'react';
import { Language } from '../types';
import { t } from '../locales';

interface DaySummaryProps {
  date: string;
  subtitle: string;
  children: React.ReactNode;
  language: Language;
  defaultOpen?: boolean;
}

const DaySummary: React.FC<DaySummaryProps> = ({ date, subtitle, children, language, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const getHeaderLabel = () => {
      const today = new Date().toDateString();
      const d = new Date(date).toDateString();
      if (d === today) return t(language, 'today');
      
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (d === yesterday.toDateString()) return t(language, 'yesterday');

      const locale = language === 'fr' ? 'fr-FR' : 'en-US';
      return new Date(date).toLocaleDateString(locale, { month: 'long', day: 'numeric', weekday: 'long' });
  };

  return (
    <div className="mb-2"> {/* Reduced bottom margin */}
      {/* Summary Header - Thinner padding */}
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-2 px-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-100 dark:border-gray-700 transition-colors hover:bg-gray-50 dark:hover:bg-gray-700/50"
      >
        <div className="flex items-baseline gap-2">
            <h3 className="text-xs font-bold text-gray-800 dark:text-white capitalize">{getHeaderLabel()}</h3>
            <span className="text-[10px] text-gray-400 dark:text-gray-500 font-medium">
                {subtitle}
            </span>
        </div>
        
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
            viewBox="0 0 20 20" 
            fill="currentColor"
        >
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>

      {/* Expanded Content - Reduced spacing */}
      {isOpen && (
        <div className="mt-2 pl-2 border-l-2 border-gray-100 dark:border-gray-800 ml-3 space-y-2 animate-slideIn">
            {children}
        </div>
      )}
    </div>
  );
};

export default DaySummary;
